import { render } from "./Catalogo.vue?vue&type=template&id=319b1c28&scoped=true"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"

import "./Catalogo.vue?vue&type=style&index=0&id=319b1c28&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319b1c28"]])

export default __exports__